import React from 'react'
import { Typography } from '@mui/material'
import {
  WithStyle,
  Testable
} from '@eventops/chronotrack-ctlive-mui'
import { CheckinEntry, EntryAddress } from '../../app/types'
import useAppSelector from '../../hooks/useAppSelector'
import { getSelectedEntrySelector } from '../../features/checkin/checkinSlice'

export const createAddress = (entry?: CheckinEntry, defaultAddress?: EntryAddress, lite?: boolean): EntryAddress => {
  return entry ? {
    locationStreet: lite ? null : entry.locationStreet,
    locationStreet2: lite ? null : entry.locationStreet2,
    locationCity: entry.locationCity,
    locationRegion: entry.locationRegion,
    locationCountry: entry.locationCountry,
    locationPostalCode: lite ? null : entry.locationPostalCode
  } : defaultAddress ?? {} as EntryAddress
}

export type AddressProps = {
  /**
   * If true, renders only as city/state
   */
  lite?: boolean,
  address?: EntryAddress,
} & WithStyle & Testable

const render = (val: string | null | undefined, addBreak?: boolean) => {
  if (!val) {
    return ''
  }
  if (addBreak) {
    return (
      <>
        <br />
        {val}
      </>
    )
  } else {
    return val
  }
}

export const Address = (props: AddressProps) => {
  const entry = useAppSelector(getSelectedEntrySelector)
  const {
    lite = false,
    address,
    className,
    style
  } = props

  const {
    locationCity,
    locationPostalCode,
    locationRegion,
    locationStreet,
    locationStreet2
  } = createAddress(entry, address, lite)

  return (
    <Typography
      data-cy={props['data-cy']}
      className={className}
      style={style}>

      {!lite && render(locationStreet)}
      {!lite && render(locationStreet2, !!locationStreet)}
      {render(locationCity, !lite && !!(locationStreet || locationStreet2))}{render(locationCity && ', ')}{render(locationRegion)} {!lite && render(locationPostalCode)}
    </Typography>
  )
}
